export const sort = {
	methods: {
		rearrangeItems,
		moveArrayElement,
	},
};

function rearrangeItems(array, sortTarget, name) {
	const MIN_LENGTH = 1;

	if (array.length > MIN_LENGTH) {
		array.forEach((element, index) => {
			for (let jIndex = 0; jIndex < sortTarget.length; jIndex++)
				if (element[name] === sortTarget[jIndex]) this.moveArrayElement(array, index, array.length);
		});
	}
}

function moveArrayElement(array, from, to) {
	const START = 0,
		DELETE_COUNT = 1;

	array.splice(to, START, array.splice(from, DELETE_COUNT)[0]);
}
